import { render, staticRenderFns } from "./generic-data-sharing.vue?vue&type=template&id=9d975536&"
import script from "./generic-data-sharing.vue?vue&type=script&lang=js&"
export * from "./generic-data-sharing.vue?vue&type=script&lang=js&"
import style0 from "./generic-data-sharing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports